<template>
  <div>
    <el-form :model="form" label-width="120px">
      <el-form-item label="上級角色名稱">
        <el-input v-model="form.parentID" :readonly="true"></el-input>
      </el-form-item>
      <el-form-item label="角色名稱">
        <el-input v-model="form.roleName"></el-input>
      </el-form-item>
      <el-form-item label="">
        <el-input v-model="form.role"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="onSubmit">确 定</el-button>
      <el-button @click="onCancel">取 消</el-button>
    </div>
  </div>
</template>

<script>
  export default {
    name: "add_or_edit",
    data() {
      return {
        form: {
          parentID: '',
          roleName: '',

        }
      }
    },
    created() {
      this.form.parentID = this.$route.query.parentRoleID
    }
  }
</script>

<style scoped>

</style>
